import pkg from "../../package.json";

const FLAG = {
    COMPRESS: "compress",
    CDN: "cdn",
    CANARY: "canary",
    UPLOAD: "upload",
    WeiHui: "weihui",
    InHos: "inhos",
    Underlay: "underlay",
    Swjw: "swjw",
};


const NODE_ENV = {
    PRODUCTION: "production",
    DEVELOPMENT: "development",
};


const NURSECARE_COMPILE_INFO = {
    VERSION: pkg.version,
    TYPE: "PC", // PC|MOBILE
};

const CDN_BASE_URLS = {
    CDN: "//static-renyuan.lianfan.com/pc/",
    UNDERLAY_CDN: "//static-zhihuyun.lianfan.com/renyuan/pc/",
    WeiHui: "//static-renyuan.weihuiyiliao.com/pc/",
};

const ROUTE_BASE_URLS = {
    NORMAL: "/pc/",
    CANARY: "/canary/pc/",
    WeiHui: "/weihuiyiliao/pc/",
};

export default {
    // TARGET,
    FLAG,
    NODE_ENV,
    NURSECARE_COMPILE_INFO,
    CDN_BASE_URLS,
    ROUTE_BASE_URLS,
};
